import { render } from "./FirmatechFooter.vue?vue&type=template&id=706df406"
import script from "./FirmatechFooter.vue?vue&type=script&lang=js"
export * from "./FirmatechFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__